import React from "react";

/** Soft separator between stacked home sections (matches warm, premium marketing tone). */
const HomeSectionDivider: React.FC = () => (
  <div role="presentation" aria-hidden className="relative z-10">
    <div className="mx-auto max-w-5xl px-4 sm:px-6">
      <div className="flex items-center gap-3 py-5 sm:py-6 md:py-7">
        <div className="h-0.5 min-w-0 flex-1 rounded-full bg-gradient-to-r from-transparent via-[#A89E91]/90 to-[#978C7E]" />
        <div className="h-1.5 w-1.5 shrink-0 rotate-45 border-2 border-[#8E8478] bg-[#EDE8E0] shadow-[0_0_0_1px_rgba(255,255,255,0.45)]" />
        <div className="h-0.5 min-w-0 flex-1 rounded-full bg-gradient-to-l from-transparent via-[#A89E91]/90 to-[#978C7E]" />
      </div>
    </div>
  </div>
);

export default HomeSectionDivider;
